export default __webpack_public_path__ + "static/media/404.89ccee0a.jpg";